import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.automatic-alerts-form', () => {
  void import('./internal/automatic-alerts-form').then(({ default: Component }) => Component());
});
